import { Injectable, inject } from '@angular/core';

import { ClientConfigDBService } from '../db/client-config-db-service';
import { Resolve } from '@angular/router';
import { InspectionTypeConfig } from '@core/api';

@Injectable()
export class InspectionTypeConfigResolver implements Resolve<InspectionTypeConfig> {
  private clientConfigDbService = inject(ClientConfigDBService);

  public resolve() {
    return this.clientConfigDbService.getInspectionTypeConfig();
  }
}
